import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Route, NavLink } from 'react-router-dom'
import { List, Icon, Label, Loader } from 'semantic-ui-react'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'

import { loadGeoObjects, createGeoObject, updateGeoObject, deleteGeoObject } from '../actions/geoObjects'
import { DEFAULT_LOCALE } from '../constants'
import GeoObjectForm from './GeoObjectForm'

const EmptyObject = () =>
  <AbsoluteDiv style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', fontSize: '3em', color: '#CCC' }}>
    <Icon name='clipboard'/>
    <div>Выберите объект</div>
  </AbsoluteDiv>

class GeoCategoryObjectsManager extends React.Component {

  state = {
    initialized: false,
    loading: false,
    deleteModal: { show: false, geoObject: null },
  }

  componentDidMount() {
    const { initialized, loading } = this.state
    if (!initialized && !loading) {
      this.loadObjects()
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.geoCategoryId !== this.props.geoCategoryId) {
      this.loadObjects()
    }
  }

  loadObjects = async () => {
    this.setState({ initialized: false, loading: true })
    await this.props.loadGeoObjects()
    this.setState({ initialized: true, loading: false })
  }

  render() {
    const { initialized, loading } = this.state
    const { match, geoObjects, geoCategoryId, updateGeoObject, createGeoObject, deleteGeoObject } = this.props

    const selectedGeoObjectId = match.params.geoObjectId

    if (!initialized && loading) { return <Loader active/> }
    else if (!initialized) { return <span/> }

    return (
      <AbsoluteDiv>
        <AbsoluteDiv attached='left' width='200px' style={{ boxShadow: '1px 0 0 rgba(0,0,0,0.1)' }}>
          <h3>Объекты</h3>
          <Label
            color='blue' as={NavLink}
            to={`/${geoCategoryId}/objects/new`}
            basic={selectedGeoObjectId !== 'new'}
          ><Icon name='plus'/> Добавить объект</Label>
          <AbsoluteDiv top='70px' scrollable style={{ padding: '0 15px 0 0' }}>
            <List>
              {geoObjects.length ? geoObjects.map(obj =>
                <List.Item
                  key={obj.id}
                  as={NavLink}
                  to={`/${geoCategoryId}/objects/${obj.id}`}
                  style={{
                    backgroundColor: selectedGeoObjectId === obj.id ? '#F0F0FF' : null,
                    padding: '10px',
                    borderRadius: '3px',
                  }}
                >
                  <List.Content style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{obj.locales[DEFAULT_LOCALE].name}</List.Content>
                </List.Item>) : <div>Нет объектов</div>}
            </List>
          </AbsoluteDiv>
        </AbsoluteDiv>
        <AbsoluteDiv left='200px'>
          <Route exact path={`/${geoCategoryId}/objects/`} component={EmptyObject}/>
          <Route path={`/${geoCategoryId}/objects/:geoObjectId`} render={({ match }) => {
            const objId = match.params.geoObjectId
            let selectedObject = objId === 'new' ? null :
              geoObjects.find(obj => obj.id === objId)
            return (
              <GeoObjectForm
                initialData={selectedObject}
                geoObjectId={objId}
                geoCategoryId={geoCategoryId}
                onSubmit={selectedObject ?
                  (data) => updateGeoObject(selectedObject.id, data) :
                  createGeoObject}
                onDelete={deleteGeoObject}
              />
            )
          }}/>
        </AbsoluteDiv>

      </AbsoluteDiv>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const category = state.geoCategories[ownProps.geoCategoryId]
  return {
    geoObjects: category.objectIds.map(oid => state.geoObjects[oid]),
  }
}

function mapsDispatchToProps(dispatch, ownProps) {
  const categoryId = ownProps.geoCategoryId
  return {
    loadGeoObjects: () => dispatch(loadGeoObjects(categoryId)),
    createGeoObject: (data) => dispatch(createGeoObject({
      ...data,
      category: categoryId,
    })),
    updateGeoObject: (id, data) => dispatch(updateGeoObject(id, data)),
    deleteGeoObject: (catId, objId) => dispatch(deleteGeoObject(catId, objId)),
  }
}

export default connect(mapStateToProps, mapsDispatchToProps)(withRouter(GeoCategoryObjectsManager))